import styled from '@emotion/styled';
import { Link, Text } from '~/shared/components';
import { cover } from '~/shared/utils/styled';
import { breakpoints } from '~/theme/breakpoints';
import Button from '~/shared/components/Button';
import { mq } from '~/lib';

export const StyledCategories = styled.div(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.space[1],

    [breakpoints.md]: {
        gridTemplateColumns: 'repeat(5, minmax(150px, 1fr))',
    },
}));

export const StyledCategory = styled.div(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    padding: `${theme.space[3]} 0`,
    [mq(0, 'md')]: {
        paddingLeft: 0,
        paddingRight: 0,
    },

    [breakpoints.md]: {
        [`&:hover ${StyledAction}`]: {
            svg: {
                transform: `translateX(${theme.space[2]})`,
            },
        },
    },
}));

export const StyledInfoContainer = styled.div(({ theme }) => ({
    [mq(0, 'md')]: {
        paddingLeft: theme.space[3],
        paddingRight: theme.space[3],
    },
}));

export const StyledImageContainer = styled.div(({ theme }) => ({
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    marginBottom: theme.space[4],
    [mq(0, 'md')]: {
        marginBottom: theme.space[3],
    },
}));

export const StyledAction = styled.div(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    fontSize: theme.fontSizes['2xs'],
    padding: `${theme.space[4]} ${theme.space[1]}`,
    gap: theme.space[2],
    svg: {
        height: '35px',
        width: '35px',
        transition: `transform 250ms ${theme.easings.smoothEase}`,
    },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
    fontSize: theme.fontSizes['2xs'],
    ...cover,
    ':hover': {
        color: `${theme.colors.primary} !important`,
        textDecoration: 'none !important',
    },
}));
export const StyledButton = styled(Button)({
    svg: {
        height: '16px',
        width: '16px',
    },
});

export const Headline = styled(Text)(({ theme }) => ({
    overflow: 'hidden',
    display: '-webkit-box !important',
    whiteSpace: 'normal',
    [mq(0, 'sm')]: {
        fontSize: theme.fontSizes['sm'],
        lineHeight: theme.fontSizes['lg'],
    },
    [mq('sm', 'md')]: {
        fontSize: theme.fontSizes['sm'],
        lineHeight: theme.fontSizes['lg'],
    },
}));

export const SubHeadline = styled(Text)(({ theme }) => ({
    overflow: 'hidden',
    whiteSpace: 'normal',
    fontSize: theme.fontSizes['xs'],
    lineHeight: theme.fontSizes['lg'],
    [mq(0, 'md')]: {
        display: 'none',
    },
}));

export const CategoryTag = styled(Text)(({ theme }) => ({
    marginBottom: theme.space[2],
}));

export const StyledArticle = styled.article(({ theme }) => ({
    columnCount: '4',
    [mq(0, 'md')]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        paddingLeft: 0,
        paddingRight: 0,
        columnGap: theme.space[3],
        columnCount: 'unset',

        [`${StyledInfoContainer}`]: {
            padding: 0,
        },
    },
}));

export const StyledArticleContainer = styled.div(() => ({
    breakInside: 'avoid-column',
    pageBreakInside: 'avoid',
}));
